export default __webpack_public_path__ + "static/media/topcharacter3.b837e350.jpeg";